import React, { useContext, useState } from "react";
import { MdClose } from "react-icons/md";
import "./Search.scss";
import Product from "../Service/Course/Jason";
import MyContext from "../../../Uttis/MyContext";

const Search = () => {
  const { showSearch, navigate, closeSearch } = useContext(MyContext);
  const [value, setValue] = useState("");

  const filteredResults = Product.filter((item) => {
    const searchTerm = value.toLowerCase();
    const courseName = item.main.toLowerCase();
    return searchTerm && courseName.startsWith(searchTerm);
  });

  return (
    <>
      {showSearch && (
        <div className="search-modal">
          <div className="search-overlay" onClick={closeSearch}></div>

          <div className="search-container">
            <div className="form-field">
              <input
                autoFocus
                type="text"
                placeholder="Search for a course..."
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
              <MdClose
                className="close-btn"
                onClick={() => (setValue(""), closeSearch())}
              />
            </div>

            <div className="search-result-content">
              {value.length === 0 ? (
                <div className="start-msg">Start typing to see results...</div>
              ) : filteredResults.length === 0 ? (
                <div className="start-msg">No results found 😔</div>
              ) : (
                <div className="search-results">
                  {filteredResults.map((item) => (
                    <div
                      className="search-result-item"
                      key={item.main}
                      onClick={() => {
                        closeSearch();
                        navigate(`/course/${item.Coursename}`);
                        setValue("");
                      }}
                    >
                      <div className="image-container">
                        <img src={item.student} alt={item.main} />
                      </div>
                      <div className="prod-details">
                        <span className="name">{item.main}</span>
                        <span className="category">{item.category}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Search;
